export const MIN_UPDATE_INTERVAL = 60 * 1000;
